import {activeTheme} from "./activeTheme"

export type {BrandLinks} from "./types"

/**
 * Theme-specific external links / allowlists for consent, markdown, and
 * support. The actual per-brand values live in each theme's
 * `ThemeDefinition` under `themes/brands/`; this module only re-exports the
 * active brand's links.
 */
export const brandLinks = activeTheme.links
